<template>
  <div class="stat-card">
    <p class="stat-card__label">{{ label }}</p>
    <p class="stat-card__value">
      {{ formattedValue
      }}<span v-if="unit" class="stat-card__unit">{{ unit }}</span>
    </p>
    <p v-if="caption" class="stat-card__caption">{{ caption }}</p>
    <div v-if="hasUsageBar" class="stat-card__bar">
      <div
        class="stat-card__bar-fill"
        :class="`stat-card__bar-fill--${barColor}`"
        :style="{ width: `${barPct}%` }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatCard",
  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], required: true },
    unit: { type: String, default: "" },
    caption: { type: String, default: "" },
    max: { type: Number, default: 0 },
  },
  computed: {
    hasUsageBar() {
      return this.max > 0 && typeof this.value === "number";
    },
    barPct() {
      if (!this.hasUsageBar) return 0;
      return Math.max(0, Math.min(100, (this.value / this.max) * 100));
    },
    barColor() {
      if (this.barPct >= 85) return "error";
      if (this.barPct >= 65) return "warning";
      return "success";
    },
    formattedValue() {
      if (typeof this.value === "number") {
        return this.value.toLocaleString();
      }
      return this.value;
    },
  },
};
</script>

<style scoped lang="scss">
.stat-card {
  &__label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: rgba(15, 23, 42, 0.5);
    font-weight: 600;
    margin: 0 0 8px;
  }

  &__value {
    font-size: 28px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.1;
    letter-spacing: -0.01em;
    margin: 0;
  }

  &__unit {
    font-size: 14px;
    font-weight: 500;
    color: rgba(15, 23, 42, 0.55);
    margin-left: 4px;
  }

  &__caption {
    font-size: 12px;
    color: rgba(15, 23, 42, 0.55);
    margin: 6px 0 0;
  }

  &__bar {
    margin-top: 12px;
    height: 6px;
    border-radius: 3px;
    background-color: rgba(15, 23, 42, 0.08);
    overflow: hidden;
  }

  &__bar-fill {
    height: 100%;
    border-radius: 3px;
    transition: width 240ms ease;

    &--success {
      background-color: #2ecc71;
    }

    &--warning {
      background-color: #f59e0b;
    }

    &--error {
      background-color: #d32f2f;
    }
  }
}
</style>
